import "./website-footer.css";
import { getAssetUrl } from "@/lib/assetBaseUrl";

function getStudentLoginUrl() {
  if (typeof window === "undefined") return "https://student.sparkl.me/login";
  const h = window.location.hostname.toLowerCase();
  if (h.includes("sparkl.ac")) return "https://student.sparkl.ac/login";
  return "https://student.sparkl.me/login";
}

const Img = ({ src, alt = "" }) => (
  <img src={src} alt={alt} className="sp-footer-media" />
);

const COMPLIANCE_BADGES = [
  {
    label: "DPDPA",
    path: "pb/compliances/0MzK927XLB4kAVIZn9wBH0tFgx333h8muwsQ15Xz.svg",
  },
  {
    label: "FERPA",
    path: "pb/compliances/MRnlJEJRdlF7xzY5ZGvpInE4GDyKNOjYgAumc9ON.svg",
  },
  {
    label: "CCPA",
    path: "pb/compliances/JMUjTX6XPSFa4Um3qwydydjZNi4EYAE9pOxqTAv6.svg",
  },
  {
    label: "GDPR",
    path: "pb/compliances/408oSxxn3TW6Bj30TJY0X5Xxd3y1GYxqd8AU4flF.svg",
  },
  {
    label: "COPPA",
    path: "pb/compliances/9JtOcQFR5CyvcTYgxdxK9hKkPoe384PD2hWNDPRH.svg",
  },
];

const DotSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    aria-hidden
    className="shrink-0"
  >
    <circle cx="4" cy="4" r="4" fill="#7A7A7A" />
  </svg>
);

export default function WebsiteFooter() {
  const year = new Date().getFullYear();

  return (
    <div className="darkBg" id="footer" data-testid="footer-section">
      <div className="maxWidthController">
        <footer className="websiteFooter">
          <div className="websiteFooter_Top">
            <div className="webFooterLogoSection">
              <div
                className="footer-compliance-badges"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                {COMPLIANCE_BADGES.map(({ label, path }) => (
                  <div key={label} className="footer-compliance-badge">
                    <img src={getAssetUrl(path)} alt={label} />
                    <span className="footer-compliance-badge-label">{label}</span>
                  </div>
                ))}
              </div>
              <p className="webFooterLogoSectionPara">
                The first free end-to-end analytics service for the site,
                designed to work with enterprises of various levels and business
                segments.
              </p>
            </div>
            <div className="webFooterLinksSection">
              <div className="topFooterLinks">
                <ul>
                  <li>
                    <a href="/about">About</a>
                  </li>
                  <li>
                    <a href="/courses">Courses</a>
                  </li>
                  <li>
                    <a href={getStudentLoginUrl()}>
                      Log in
                    </a>
                  </li>
                  <li>
                    <a
                      href="/register"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="registerLink"
                      data-register-ref=""
                      id="home-register-footer"
                    >
                      <button type="button" className="loginBtn">
                        Register
                      </button>
                    </a>
                  </li>
                </ul>
              </div>

              <div className="socialConnection">
                <div className="socialConnectionNumberEmail">
                  <div className="linksPointer">
                    <DotSvg />
                    Contact us
                  </div>
                  <div className="contactLinks">
                    <a href="tel:+918800028514">+91 880 002 8514</a>
                    <a href="mailto:hello@sparkl.me">hello@sparkl.me</a>
                  </div>
                </div>
                <div className="socialMediaLinks">
                  <div className="linksPointer">
                    <DotSvg />
                    Follow us on
                  </div>

                  <div className="socialMediaIcons">
                    <div className="socialMediaIconCircle">
                      <a
                        href="https://www.youtube.com/@SparklEdventure"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Img src="/assets/img/homepage/footerlinks/youtube.svg" />
                      </a>
                    </div>
                    <div className="socialMediaIconCircle">
                      <a
                        href="https://www.instagram.com/sparkledventure"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Img src="/assets/img/homepage/footerlinks/instagram.svg" />
                      </a>
                    </div>
                    <div className="socialMediaIconCircle">
                      <a
                        href="https://www.linkedin.com/company/sparkl-edventure"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Img src="/assets/img/homepage/footerlinks/linkedin.svg" />
                      </a>
                    </div>
                    <div className="socialMediaIconCircle">
                      <a
                        href="https://www.facebook.com/people/Sparkl-Edventure/61563873962227/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Img src="/assets/img/homepage/footerlinks/facebook.svg" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="websiteFooter_Bottom">
            <div className="courseCat">
              <DotSvg />
              course categories
            </div>

            <div className="linksGridSystem">
              <div className="linksGridSystem_row">
                <div className="CourseOf">IB</div>
                <div className="courseLinksGrid">
                  <div>
                    <div className="courseCategory">MYP 4</div>
                    <a className="footerCourseNames" href="/course/ib-myp4/extended-mathematics">
                      Extended Mathematics
                    </a>
                    <a className="footerCourseNames" href="/course/ib-myp4/standard-mathematics">
                      Standard Mathematics
                    </a>
                    <a className="footerCourseNames" href="/course/ib-myp4/physics">
                      Physics
                    </a>
                    <a className="footerCourseNames" href="/course/ib-myp4/chemistry">
                      Chemistry
                    </a>
                    <a className="footerCourseNames" href="/course/ib-myp4/biology">
                      Biology
                    </a>
                  </div>
                  <div>
                    <div className="courseCategory">MYP 5</div>
                    <a className="footerCourseNames" href="/course/ib-myp5/extended-mathematics">
                      Extended Mathematics
                    </a>
                    <a className="footerCourseNames" href="/course/ib-myp5/standard-mathematics">
                      Standard Mathematics
                    </a>
                    <a className="footerCourseNames" href="/course/ib-myp5/physics">
                      Physics
                    </a>
                    <a className="footerCourseNames" href="/course/ib-myp5/chemistry">
                      Chemistry
                    </a>
                    <a className="footerCourseNames" href="/course/ib-myp5/biology">
                      Biology
                    </a>
                  </div>
                  <div>
                    <div className="courseCategory">DP 1</div>
                    <a className="footerCourseNames" href="/course/ib-dp1/math-aa-hl">
                      Math AA HL
                    </a>
                    <a className="footerCourseNames" href="/course/ib-dp1/math-aa-sl">
                      Math AA SL
                    </a>
                    <a className="footerCourseNames" href="/course/ib-dp1/math-ai-sl">
                      Math AI SL
                    </a>
                    <a className="footerCourseNames" href="/course/ib-dp1/physics-hl">
                      Physics HL
                    </a>
                    <a className="footerCourseNames" href="/course/ib-dp1/physics-sl">
                      Physics SL
                    </a>
                    <a className="footerCourseNames" href="/course/ib-dp1/chemistry-hl">
                      Chemistry HL
                    </a>
                    <a className="footerCourseNames" href="/course/ib-dp1/chemistry-sl">
                      Chemistry SL
                    </a>
                    <a className="footerCourseNames" href="/course/ib-dp1/biology-hl">
                      Biology HL
                    </a>
                    <a className="footerCourseNames" href="/course/ib-dp1/biology-sl">
                      Biology SL
                    </a>
                  </div>
                  <div>
                    <div className="courseCategory">DP 2</div>
                    <a className="footerCourseNames" href="/course/ib-dp2/math-aa-hl">
                      Math AA HL
                    </a>
                    <a className="footerCourseNames" href="/course/ib-dp2/math-aa-sl">
                      Math AA SL
                    </a>
                    <a className="footerCourseNames" href="/course/ib-dp2/math-ai-sl">
                      Math AI SL
                    </a>
                    <a className="footerCourseNames" href="/course/ib-dp2/physics-hl">
                      Physics HL
                    </a>
                    <a className="footerCourseNames" href="/course/ib-dp2/physics-sl">
                      Physics SL
                    </a>
                    <a className="footerCourseNames" href="/course/ib-dp2/chemistry-hl">
                      Chemistry HL
                    </a>
                    <a className="footerCourseNames" href="/course/ib-dp2/chemistry-sl">
                      Chemistry SL
                    </a>
                    <a className="footerCourseNames" href="/course/ib-dp2/biology-hl">
                      Biology HL
                    </a>
                    <a className="footerCourseNames" href="/course/ib-dp2/biology-sl">
                      Biology SL
                    </a>
                  </div>
                </div>
              </div>

              <div className="linksGridSystem_row">
                <div className="CourseOf">Cambridge</div>
                <div className="courseLinksGrid">
                  <div>
                    <div className="courseCategory">IGCSE Grade 9</div>
                    <a className="footerCourseNames" href="/course/igcse-grade9/extended-mathematics">
                      Extended Mathematics
                    </a>
                    <a className="footerCourseNames" href="/course/igcse-grade9/extended-physics">
                      Extended Physics
                    </a>
                    <a className="footerCourseNames" href="/course/igcse-grade9/extended-chemistry">
                      Extended Chemistry
                    </a>
                    <a className="footerCourseNames" href="/course/igcse-grade9/extended-biology">
                      Extended Biology
                    </a>
                  </div>
                  <div>
                    <div className="courseCategory">IGCSE Grade 10</div>
                    <a className="footerCourseNames" href="/course/igcse-grade10/extended-mathematics">
                      Extended Mathematics
                    </a>
                    <a className="footerCourseNames" href="/course/igcse-grade10/extended-physics">
                      Extended Physics
                    </a>
                    <a className="footerCourseNames" href="/course/igcse-grade10/extended-chemistry">
                      Extended Chemistry
                    </a>
                    <a className="footerCourseNames" href="/course/igcse-grade10/extended-biology">
                      Extended Biology
                    </a>
                  </div>
                </div>
              </div>

              <div className="linksGridSystem_row">
                <div className="CourseOf">AP</div>
                <div className="courseLinksGrid">
                  <div>
                    <div className="courseCategory">Math</div>
                    <a className="footerCourseNames" href="/course/ap/math-precalculus">
                      AP Precalculus
                    </a>
                    <a className="footerCourseNames" href="/course/ap/math-calculus-ab">
                      AP Calculus AB
                    </a>
                    <a className="footerCourseNames" href="/course/ap/math-calculus-bc">
                      AP Calculus BC
                    </a>
                    <a className="footerCourseNames" href="/course/ap/math-statistics">
                      AP Statistics
                    </a>
                  </div>
                  <div>
                    <div className="courseCategory">Physics</div>
                    <a className="footerCourseNames" href="/course/ap/physics-1-algebra-based">
                      AP Physics 1
                    </a>
                    <a className="footerCourseNames" href="/course/ap/physics-2-algebra-based">
                      AP Physics 2
                    </a>
                    <a className="footerCourseNames" href="/course/ap/physics-c-mechanics">
                      AP Physics C: Mechanics
                    </a>
                    <a className="footerCourseNames" href="/course/ap/physics-c-electricity-and-magnetism">
                      AP Physics C: Electricity &amp; Magnetism
                    </a>
                  </div>
                  <div>
                    <div className="courseCategory">Chemistry</div>
                    <a className="footerCourseNames" href="/course/ap/chemistry">
                      AP Chemistry
                    </a>
                  </div>
                  <div>
                    <div className="courseCategory">Biology</div>
                    <a className="footerCourseNames" href="/course/ap/biology">
                      AP Biology
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bottomfooterLinks bottomfooterLinksIndex">
            <div className="disclaimerTextIndex">
              © {year}{" "}
              <i>Sparkl Edventure Pvt. Ltd.</i> — Independent Personalized tutoring, AI learning
              and test-prep platform. All exam names (SAT®, ACT®, AP®, GRE®, GMAT®, NEET, JEE, IGCSE®,
              IB®) are trademarks of their respective owners. <i>No affiliation or endorsement implied</i>.
            </div>
            <div className="footerLeftLinks">
              <a href="/terms" className="bottomfooterLinksText">
                Terms and Conditions
              </a>
              <a href="/policy" className="bottomfooterLinksText">
                Privacy Policy
              </a>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}
